import { render, staticRenderFns } from "./vendedores.vue?vue&type=template&id=3342f7b7&scoped=true"
import script from "./vendedores.vue?vue&type=script&lang=js"
export * from "./vendedores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3342f7b7",
  null
  
)

export default component.exports